/* iTOVi — immersive scroll "How it works" sequence (palm-scanner journey + remote Face Scan).
   Scroll drives the active frame; each frame starts at the full view and zooms in as you
   scroll through it, then cross-fades into the next. Frames can be <video> (clips) or <img>.
   Clips only play once the section is on-screen, and always (re)start from frame 0 — so the
   first clip unveils from the box instead of having silently finished while off-screen. */
(function(){
  function initTrack(track){
    const frames   = [...track.querySelectorAll('.imm-frame')];
    const chapters = [...track.querySelectorAll('.imm-chapter')];
    const bars     = [...track.querySelectorAll('.imm-progress i')];
    const sticky   = track.querySelector('.imm-sticky') || track;
    const N = frames.length;
    if (!N) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let cur = -1;
    let visible = false;

    function pauseAll(){ frames.forEach(f => { if (typeof f.pause === 'function'){ try { f.pause(); } catch(e){} } }); }
    function playFrom0(i){
      const f = frames[i];
      if (reduce || !f || typeof f.play !== 'function') return;
      try { f.currentTime = 0; } catch(e){}
      const p = f.play(); if (p && p.catch) p.catch(()=>{});
    }

    function setActive(idx, sub){
      if (idx !== cur){
        cur = idx;
        frames.forEach((f,i) => f.classList.toggle('on', i === idx));
        chapters.forEach((c,i) => c.classList.toggle('on', i === idx));
        if (visible){ pauseAll(); playFrom0(idx); }   // only play while the section is on-screen
      }
      const z = reduce ? 0 : sub * 0.10;
      if (frames[idx]) frames[idx].style.transform = 'scale(' + (1 + z).toFixed(4) + ')';
      bars.forEach((b,i) => b.style.setProperty('--p', i < idx ? '100%' : (i === idx ? (sub*100).toFixed(1)+'%' : '0%')));
    }

    function update(){
      const rect = track.getBoundingClientRect();
      const total = track.offsetHeight - window.innerHeight;
      const scrolled = Math.min(Math.max(-rect.top, 0), total);
      const p = total > 0 ? scrolled / total : 0;
      const raw = Math.min(N - 0.0001, p * N);
      const idx = Math.floor(raw);
      setActive(idx, raw - idx);
    }
    // rAF-throttle so we touch layout/transform at most once per frame (kills scroll jank)
    let ticking = false;
    function onScroll(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){ update(); ticking = false; });
    }

    // Gate playback on visibility: start the active clip from the top when the section
    // scrolls into view, and pause everything when it leaves (so clip 1 unveils from the box
    // instead of having silently played to its end while still below the fold).
    if ('IntersectionObserver' in window){
      const io = new IntersectionObserver(function(entries){
        const wasVisible = visible;
        visible = entries[0].isIntersecting && entries[0].intersectionRatio > 0.4;
        if (visible && !wasVisible){ pauseAll(); playFrom0(cur < 0 ? 0 : cur); }
        else if (!visible && wasVisible){ pauseAll(); }
      }, { threshold:[0, 0.4, 0.75] });
      io.observe(sticky);
    } else { visible = true; }

    setActive(0, 0);   // set initial frame/scale only — playback is triggered by the observer
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll, { passive:true });
    update();
  }

  document.querySelectorAll('.imm-track').forEach(initTrack);
})();
